import React from 'react';
import { Row, Col, Card, Button, Spinner } from 'react-bootstrap';

export default function CareersList({ carreras, isLoading, onEdit }) {
  if (isLoading) {
    return (
      <Row className='mt-5'>
        <Col className='text-center'>
          <Spinner animation='border' role='status'>
            <span className='sr-only'>Cargando...</span>
          </Spinner>
        </Col>
      </Row>
    );
  }

  if (!carreras || carreras.length === 0) {
    return (
      <Row>
        <Col className='text-center mt-5'>
          <p className='text-muted'>No hay carreras disponibles</p>
        </Col>
      </Row>
    );
  }

  return (
    <Row className='g-4'>
      {carreras.map((carrera) => (
        <Col key={carrera._id} md={6} lg={4} className='mb-3'>
          <Card className='h-100 shadow-sm'>
            <Card.Body>
              <Card.Title className='text-truncate' title={carrera.name}>
                {carrera.name}
              </Card.Title>

              <div className='mb-3'>
                {carrera.description && (
                  <p className='text-muted small text-truncate'>
                    {carrera.description}
                  </p>
                )}

                <div className='mt-2'>
                  {carrera.durationMonths && (
                    <div className='small'>
                      <strong>Duracion:</strong> {carrera.durationMonths} mes
                      {carrera.durationMonths !== 1 ? 'es' : ''}
                    </div>
                  )}

                  {carrera.modulesCount && (
                    <div className='small'>
                      <strong>Modulos:</strong> {carrera.modulesCount}
                    </div>
                  )}

                  {Array.isArray(carrera.courses) && (
                    <div className='small'>
                      <strong>Cursos:</strong> {carrera.courses.length}
                    </div>
                  )}

                  {carrera.createdAt && (
                    <div className='small'>
                      <strong>Creado:</strong>{' '}
                      {new Date(carrera.createdAt).toLocaleDateString('es-AR')}
                    </div>
                  )}

                  {carrera.enable !== undefined && (
                    <div className='small'>
                      <strong>Estado:</strong>{' '}
                      <span
                        className={
                          carrera.enable
                            ? 'badge badge-success'
                            : 'badge badge-secondary'
                        }
                      >
                        {carrera.enable ? 'Activa' : 'Inactiva'}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </Card.Body>

            <Card.Footer className='bg-transparent border-top-0'>
              <Button
                variant='success'
                size='sm'
                className='w-100'
                onClick={() => onEdit(carrera)}
              >
                <i className='mr-2 fas fa-edit' />
                Editar
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      ))}
    </Row>
  );
}